/**
 * Verify step functions for arcano.app
 * This code is under copyright Arcano Gmbh (https://arcano.app).
 *
 * - no commercial use
 * - no modifications
 * - no redistribution
 *
 * without written consent of Arcano Gmbh, zentralstrasse 47, 8003 zürich, switzerland, https://arcano.app
*/
import {mfetch} from "./utils";

export function setupVerification() {
    let form = document.getElementById('verificationForm') as HTMLFormElement;
    if(!form) {
        return
    }

    form.addEventListener('submit', (e) => {
        e.preventDefault()

        document.querySelectorAll('.verification-error').forEach(el => el.remove())
        let data = new FormData(form);
        mfetch(form.action, {
            method: 'POST',
            body: data
        }).then(async response => {
            if(response.status === 200) {
                const url = await response.text()
                window.location.href = url
            } else {
                const data = await response.json()
                let input = document.getElementById('verification_code') as HTMLInputElement;

                let elem = document.createElement('div')
                elem.classList.add('verification-error', 'errors')
                elem.innerText = data[0]
                input.parentElement!.appendChild(elem)
            }
        })
    })

    const resendButton = document.getElementById('resend-verification-button') as HTMLButtonElement;
    const resendOk = document.getElementById('check-resend-sign') as HTMLButtonElement
    const resendNotif = document.getElementById('resend-verification-notification') as HTMLButtonElement;

    resendButton.addEventListener('click', (e) => {
        e.preventDefault()
        const currentTarget = e.currentTarget as HTMLAnchorElement;
        fetch(currentTarget.href).then(response => {
            if(response.status === 200) {
                resendOk.classList.add('d-inline')
                resendButton.classList.add('d-none')
                resendNotif.classList.remove('d-none')
            } else {
                console.log('problem')
            }
        })
    })
}
